import React from 'react';
import { SEO } from '../components/shared/SEO';
import { ScrollToTopSection } from './home/ScrollToTopSection';
import { EyebrowSection } from './home/EyebrowSection';
import { HeaderSection } from './home/HeaderSection';
import { HeroSection } from './home/HeroSection';
import { ProductKitsSection } from './home/ProductKitsSection';
import { TrustBoxSection } from './home/TrustBoxSection';
import { BenefitsSection } from './home/BenefitsSection';
import { ROICalculatorSection } from './home/ROICalculatorSection';
import { HowItWorksSection } from './home/HowItWorksSection';
import { ProblemSolutionSection } from './home/ProblemSolutionSection';
import { TestimonialsSection } from './home/TestimonialsSection';
import { WhoItsForSection } from './home/WhoItsForSection';
import { FAQSection } from './home/FAQSection';
import { ClosingCTASection } from './home/ClosingCTASection';
import { FooterSection } from './home/FooterSection';
export function HomePage() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-666">
      <ScrollToTopSection data-id="element-667" />
      <SEO title="Precision Pro Sprayers | ForceX Plug-and-Play Electric Sprayers" description="Professional plug-and-play electric sprayers built for contractors. Eliminate pouring, reduce spills, and finish jobs faster with ForceX sprayer kits." data-id="element-668" />
      <EyebrowSection data-id="element-669" />
      <HeaderSection data-id="element-670" />
      <main className="flex-grow" data-id="element-671">
        <HeroSection data-id="element-672" />
        <ProductKitsSection data-id="element-673" />
        <TrustBoxSection data-id="element-674" />
        <BenefitsSection data-id="element-675" />
        <ROICalculatorSection data-id="element-676" />
        <HowItWorksSection data-id="element-677" />
        <ProblemSolutionSection data-id="element-678" />
        <WhoItsForSection data-id="element-679" />
        <TestimonialsSection data-id="element-680" />
        <FAQSection data-id="element-681" />
        <ClosingCTASection data-id="element-682" />
      </main>
      <FooterSection data-id="element-683" />
    </div>;
}